/**
 * Builds the canonical share URL for a certificate.
 * Points to the certificate-og edge function which:
 *  - Returns rich Open Graph HTML for social-media crawlers (so WhatsApp,
 *    iMessage, Twitter, etc. show the actual certificate as a preview).
 *  - 302-redirects real users to /certificate/:id (the React SPA route).
 */
const SUPABASE_PROJECT_ID = import.meta.env.VITE_SUPABASE_PROJECT_ID as string;

export function getCertificateShareUrl(certificateId: string): string {
  if (!SUPABASE_PROJECT_ID) {
    // Fallback to direct SPA route if env is missing
    return `${window.location.origin}/certificate/${certificateId}`;
  }
  return `https://${SUPABASE_PROJECT_ID}.supabase.co/functions/v1/certificate-og/${certificateId}`;
}

export function buildCertificateWhatsAppMessage(params: {
  goalTitle: string;
  userName: string;
  shareUrl: string;
}): string {
  const { goalTitle, userName, shareUrl } = params;
  return (
    `🏆 I just completed a goal on GoalDigger!\n\n` +
    `🎯 ${goalTitle}\n` +
    `👤 ${userName}\n\n` +
    `Check out my certificate: ${shareUrl}\n\n` +
    `Set your own goals at GoalDigger 💪`
  );
}
